// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_2cHutWp","createGameModal":"_ovYrEXS","body":"_r2s2s8G","content":"_Z73d-Ku","container":"_14sDxLz","inner":"_2bWHOjQ","bannerBg":"_1mEK2rn"};